/**
 * body要素にpageNamesに含まれるクラスがついているか判定
 * @param {string[]|string} pageNames
 * @returns {boolean}
 */
export function isPage(...pageNames) {
  return pageNames.some((pageName) => document.body.classList.contains(pageName));
}

/**
 * 画面幅とユーザーエージェントを使って、モバイルかどうかを判定
 * @returns {boolean}
 */
export const isMobile = () => {
  const windowWidth = window.innerWidth;
  const breakpoint = 768;
  const isMobileUserAgent = /iphone|ipod|android.*mobile|windows.*phone|blackberry.*mobile/.test(
    navigator.userAgent.toLowerCase()
  );

  return windowWidth <= breakpoint || isMobileUserAgent;
};
